import { ChevronRightIcon, LockClosedIcon } from '@heroicons/react/20/solid';
import { ReactNode } from 'react';

export type BreadcrumbSection = {
    label: ReactNode;
    value: string;
    selected?: boolean;
    locked?: boolean;
};

type BreadcrumbsProps = {
    sections: BreadcrumbSection[];
    onClick: (value: string) => void;
    size?: 'regular' | 'small';
};

function Breadcrumbs({ sections, onClick, size = 'regular' }: BreadcrumbsProps): JSX.Element {
    function handleSectionClick(value: string): void {
        onClick(value);
    }

    return (
        <nav className="flex" aria-label="Breadcrumb">
            <ol role="list" className={`flex items-center ${size === 'regular' ? 'space-x-4' : ''}`}>
                <li>
                    <div className="flex items-center">
                        <SingleSection section={sections[0]} onClick={handleSectionClick} size={size} />
                    </div>
                </li>

                {sections.slice(1).map((section, idx) => {
                    return (
                        <li key={idx}>
                            <div className="flex items-center">
                                <ChevronRightIcon
                                    className={`flex-shrink-0 text-gray-400 ${size === 'regular' ? 'h-5 w-5' : 'h-4 w-4'}`}
                                    aria-hidden="true"
                                />
                                <span className={`flex items-center ${size === 'regular' ? 'ml-4' : ''}`}>
                                    {section.locked && <LockClosedIcon className="h-3.5 w-3.5 text-gray-500 mr-1" />}
                                    <SingleSection section={section} onClick={handleSectionClick} size={size} />
                                </span>
                            </div>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}

type SectionProps = {
    section: BreadcrumbSection;
    onClick: (value: string) => void;
    size?: 'regular' | 'small';
};

function SingleSection({ section, onClick, size = 'regular' }: SectionProps): JSX.Element {
    const _section = section;

    return (
        <span
            onClick={(): void => onClick(_section.value)}
            className={`${_section?.selected ? 'cursor-default' : 'cursor-pointer hover:text-gray-700'} ${
                size === 'regular' ? 'text-sm font-medium text-gray-500' : 'text-xs text-gray-400'
            } block `}
            aria-current={_section?.selected ? 'page' : undefined}
        >
            {_section?.label}
        </span>
    );
}

// function MultiSection({ section, onClick, size }: SectionProps): JSX.Element {
//     return (
//         <span className="cursor-pointer hover:text-gray-700 selection:text-sm font-medium text-gray-500 flex items-center">
//             <Dropdown dotsDirection="horizontal" menuPosition="right">
//                 {section.map((item) => {
//                     return (
//                         <Dropdown.Option
//                             key={item.value}
//                             label={item.label as string}
//                             value={item.value}
//                             onClick={(v): void => onClick(v.toString())}
//                         />
//                     );
//                 })}
//             </Dropdown>
//         </span>
//     );
// }

export default Breadcrumbs;
